import { toast } from "react-toastify";
import { API_URL } from "../../_services/apiUrl";
import { get } from "../../_services/apiService";
import { Link, useNavigate } from "react-router-dom";
import { decryptData } from "../../_services/encDnc";
import { addToCart, buyNow } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useWishlist } from "../../context/wishlistContext";
import React, { startTransition, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const ProductDetailSection = () => {
    const isFirstRender = useRef(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [size, setSize] = useState([]);
    const [skuId, setSkuId] = useState(null);
    const loginId = localStorage.getItem('loginId');
    const [userAddress, setUserAdderss] = useState([]);
    const [filteredSku, setFilteredSku] = useState(null);
    const [productDetail, setProductDetail] = useState();
    const colorId = Number(localStorage.getItem('colorId'));
    const [selectedColorId, setSelectedColorId] = useState(productDetail?.productSkuDtos ? productDetail?.productSkuDtos[0]?.colorId : 0);
    const { addToWishlist, removeFromWishlist } = useWishlist();
    const [selectedSizeType, setSelectedSizeType] = useState(null);
    const [selectedColorName, setSelectedColorName] = useState(null);

    // const cartData = useSelector((state) => state.cartReducer.cart) || [];

    const rawCartData = useSelector((state) => state.cartReducer.cart);

    const cartData = useMemo(() => rawCartData || [], [rawCartData]);

    const cartQuantity = cartData.find(cartItem => Number(cartItem.productId) === Number(productDetail?.productId));

    const initialQuantity = cartQuantity ? cartQuantity.quantity : 1;

    const [quantity, setQuantity] = useState(initialQuantity);

    const [formData, setFormData] = useState({
        skuId: 0,
        createdBy: 0,
        buyStatus: 1,
        cartItemId: 0,
        isActive: true,
        quantity: loginId ? initialQuantity + 1 : initialQuantity,
        loginId: loginId ? Number(loginId) : 0,
        unitPrice: filteredSku?.salePrice || 0,
        totalAmount: filteredSku?.salePrice || 0,
        productId: productDetail?.productId ? Number(productDetail?.productId) : 0,
        taxId: productDetail?.taxId || 0,
        taxAmount: productDetail?.taxAmount || 0
    });

    const [buyFormData, setBuyFormData] = useState({
        skuId: 0,
        cartItemId: 0,
        productId: productDetail?.productId ? Number(productDetail?.productId) : 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: 1,
        quantity: quantity,
        isActive: true,
        createdBy: 0,
        unitPrice: filteredSku?.salePrice || 0,
        totalAmount: filteredSku?.salePrice || 0,
        taxId: productDetail?.taxId || 0,
        taxAmount: productDetail?.taxAmount || 0
    });

    useEffect(() => {
        const firstActiveSize = size?.find((item) => item?.status === true);

        if (firstActiveSize) {
            setSelectedSizeType(firstActiveSize);
            setSkuId(firstActiveSize?.skuId);
        }
    }, [size, setSelectedSizeType]);

    const [wishListForm, setWishListForm] = useState({
        wishProductId: 0,
        loginId: loginId ? Number(loginId) : 0,
        productId: 0,
        isActive: true,
        createdBy: 0
    });

    const incrementQuantity = () => {
        setQuantity(prevQuantity => prevQuantity + 1);
    };

    const decrementQuantity = () => {
        if (quantity > 1) {
            setQuantity(prevQuantity => prevQuantity - 1);
        }
    };

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            quantity: quantity + initialQuantity,
            totalAmount: filteredSku?.salePrice * quantity,
        }));
    }, [quantity, initialQuantity, filteredSku?.salePrice]);

    useEffect(() => {
        if (productDetail && productDetail.productId) {
            setFormData({
                skuId: skuId || 0,
                cartItemId: 0,
                productId: Number(productDetail.productId),
                loginId: Number(loginId),
                buyStatus: 1,
                quantity: loginId ? initialQuantity + 1 : initialQuantity,
                isActive: true,
                createdBy: 0,
                unitPrice: filteredSku?.salePrice || 0,
                totalAmount: filteredSku?.salePrice || 0,
                taxId: productDetail?.taxId || 0,
                taxAmount: productDetail?.taxAmount || 0,
            });
        }
    }, [productDetail, initialQuantity, loginId, filteredSku, skuId]);

    useEffect(() => {
        setBuyFormData((prevData) => ({
            ...prevData,
            quantity: quantity,
            totalAmount: filteredSku?.salePrice * quantity,
        }));
    }, [quantity, filteredSku?.salePrice]);

    useEffect(() => {
        if (productDetail && productDetail?.productId) {
            setBuyFormData({
                skuId: skuId || 0,
                cartItemId: 0,
                productId: Number(productDetail?.productId),
                loginId: Number(loginId),
                buyStatus: 1,
                quantity: quantity,
                isActive: true,
                createdBy: 0,
                unitPrice: filteredSku?.salePrice || 0,
                totalAmount: filteredSku?.salePrice || 0,
                taxId: productDetail?.taxId || 0,
                taxAmount: productDetail?.taxAmount || 0,
            });
        }
    }, [productDetail, loginId, filteredSku, skuId, quantity]);

    const GetProductDetail = useCallback(async () => {
        try {
            const response = await get(API_URL?.GetProductDetailByIsHome + `?pLoginId=${loginId || 0}`);
            if (response.isSuccess === 200) {
                setProductDetail(response?.data[0]);
            } else {
                setProductDetail([]);
            }
        } catch (error) {
            setProductDetail([]);
        } finally {
            setLoading(false);
        }
    }, [loginId]);

    const getUserAddressByLoginId = useCallback(async () => {
        if (loginId) {
            setLoading(true);
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);

                const encryptedData = response?.data;
                const result = decryptData(encryptedData);

                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                }
            } catch (error) {
                setUserAdderss([]);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    const GetProductSkuByProductColorId = useCallback(async (colorId) => {
        try {
            if (!productDetail?.productId) {
                return;
            }

            const url = `${API_URL.GetProductSkuByProductColorId}?ProductId=${productDetail?.productId}&ColorId=${colorId}`;
            const response = await get(url);
            if (response.isSuccess === 1) {
                setSize(response?.data);
            }
        } catch (error) {
            setSize([]);
        } finally {
            setLoading(false);
        }
    }, [productDetail]);

    useEffect(() => {
        if (productDetail?.productId && isFirstRender.current) {
            GetProductSkuByProductColorId(productDetail.productSkuDtos ? productDetail?.productSkuDtos[0]?.colorId : 0);
            isFirstRender.current = false;
        }
    }, [productDetail, GetProductSkuByProductColorId]);

    useEffect(() => {
        GetProductDetail();
        getUserAddressByLoginId();
    }, [GetProductDetail, getUserAddressByLoginId]);

    const handleImageError = (e) => {
        e.target.src = './images/defaultImage.png';
    };

    const onBuyNow = async () => {
        sessionStorage.removeItem("previousUrl");

        if (skuId === 0 || skuId === null) {
            alert('Please Select Size');
            return;
        }

        try {
            await dispatch(buyNow(buyFormData));
            if (loginId) {

                if (userAddress != null && userAddress.length > 0) {
                    localStorage.setItem('selectedAddressId', userAddress[0].addressId);
                    navigate("/checkout");
                } else {
                    navigate("/shipping-address");
                }
            } else {
                navigate('/login')
            }
        } catch (error) {
            toast.error("Error occurred while adding to cart.");
        }
    };

    const onAddCart = async () => {
        if (skuId === 0 || skuId === null) {
            alert('Please Select Size');
            return;
        }

        try {
            if (loginId) {
                await dispatch(addToCart(formData));
            } else {
                await dispatch(addToCart(formData, quantity));
            }

            setTimeout(() => {
                navigate('/cart');
            }, 500);

        } catch (error) {
            toast.error("Item not Added in Cart");
        }
    };

    const onWishlistToggle = async (item) => {
        if (loginId) {
            const updatedWishListForm = {
                ...wishListForm,
                productId: item?.productId || 0
            };

            setWishListForm(updatedWishListForm);

            if (item.wishStatus) {
                await removeFromWishlist(item);
                GetProductDetail();
                toast.success('Remove to wishlist!');
            } else {
                await addToWishlist(updatedWishListForm);
                GetProductDetail();
                toast.success('Add to wishlist!');
            }
        } else {
            startTransition(() => {
                navigate('/login');
            })
        }
    };

    const handleColorChange = (colorId, colorTypeName, skuId) => {
        localStorage.setItem('colorId', colorId);
        localStorage.setItem('colorTypeName', colorTypeName);
        localStorage.setItem('skuId', skuId);
        localStorage.removeItem('sizeTypeName');
        setSelectedSizeType(null);
        setSelectedColorId(colorId);
        GetProductSkuByProductColorId(colorId);
        setSelectedColorName(colorTypeName);
    };

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            skuId: skuId || 0,
            quantity: initialQuantity,
            buyStatus: 1
        }));
    }, [skuId, cartData, initialQuantity]);

    useEffect(() => {
        setBuyFormData((prevFormData) => ({
            ...prevFormData,
            skuId: skuId || 0,
            unitPrice: filteredSku?.salePrice,
            totalAmount: filteredSku?.salePrice,
            buyStatus: 1
        }));
    }, [skuId, filteredSku]);

    const selectedSize = (item) => {
        setSelectedSizeType(item);
        setSkuId(item?.skuId);

        const filteredData = productDetail?.productSkuDtos?.find(
            (sku) => sku.sizeTypeId === item?.sizeTypeId
        );
        localStorage.setItem('sizeTypeName', item?.name);

        setFilteredSku(filteredData);
    };

    useEffect(() => {
        if (selectedSizeType?.sizeTypeId) {
            const filteredData = productDetail?.productSkuDtos?.find(
                (sku) => sku.sizeTypeId === selectedSizeType?.sizeTypeId
            );
            setFilteredSku(filteredData);
        }
    }, [selectedSizeType, productDetail?.productSkuDtos]);

    const filteredProductSkuDtos = colorId
        ? productDetail?.productSkuDtos?.filter(item => item.colorId === colorId)
        : productDetail?.productSkuDtos;

    const onProductDetail = (item) => {
        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }
        localStorage.setItem('productId', item?.productId);

        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
    }

    const calculateDiscountPercent = (mrp, unitPrice) => {
        if (mrp && unitPrice && mrp > unitPrice) {
            return ((mrp - unitPrice) / mrp) * 100;
        }
        return 0;
    };

    const discountPercent = calculateDiscountPercent(filteredSku?.mrp || productDetail?.mrp, filteredSku?.salePrice || productDetail?.unitPrice);

    if (loading) return <div>loading...</div>;

    return (
        <>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            {productDetail && (
                <section className="product_show_wepper">
                    <div className="product_list_wepper">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="product_img_wepper">
                                        <div className="product_img_inner">
                                            {filteredProductSkuDtos && filteredProductSkuDtos?.length > 0 && filteredProductSkuDtos[0]?.productImageDtos && filteredProductSkuDtos[0].productImageDtos.length > 0 ? (
                                                <img
                                                    src={`${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[0]?.imgPath}`}
                                                    alt="ProductImage"
                                                    data-aos="fade-right"
                                                    onError={handleImageError}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        (productDetail?.productImageDtos?.[0]?.imgPath ? `${imageUrl}${productDetail.productImageDtos[0]?.imgPath}` : './images/defaultImage.png')
                                                    }
                                                    alt="ProductImage"
                                                    data-aos="fade-right"
                                                    onError={handleImageError}
                                                />
                                            )}

                                            <div className="product-left-img">
                                                {filteredProductSkuDtos && filteredProductSkuDtos.length > 0 && filteredProductSkuDtos[0].productImageDtos && filteredProductSkuDtos[0].productImageDtos.length > 0 ? (
                                                    <>
                                                        <img
                                                            src={`${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[0]?.imgPath}` || './images/defaultImage.png'}
                                                            alt="ProductImage"
                                                            className="top-half-img"
                                                            data-aos="fade-up"
                                                            onError={handleImageError}
                                                        />
                                                        <img
                                                            src={`${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[0]?.imgPath}` || './images/defaultImage.png'}
                                                            alt="ProductImage"
                                                            className="bottom-half-img"
                                                            data-aos="fade-down"
                                                            onError={handleImageError}
                                                        />
                                                    </>
                                                ) : (
                                                    <>
                                                        <img
                                                            src={
                                                                (productDetail?.productImageDtos?.[0]?.imgPath ? `${imageUrl}${productDetail.productImageDtos[0]?.imgPath}` : './images/defaultImage.png')
                                                            }
                                                            alt="ProductImage"
                                                            className="top-half-img"
                                                            data-aos="fade-up"
                                                            onError={handleImageError}
                                                        />
                                                        <img
                                                            src={
                                                                (productDetail?.productImageDtos?.[0]?.imgPath ? `${imageUrl}${productDetail.productImageDtos[0]?.imgPath}` : './images/defaultImage.png')
                                                            }
                                                            alt="ProductImage"
                                                            className="bottom-half-img"
                                                            data-aos="fade-down"
                                                            onError={handleImageError}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="product_right_wepper">
                                        <div className="product_right_inner">
                                            <h2 className="product_name_home mb-0">{productDetail?.displayName}</h2>
                                            <p className="short_description_home" dangerouslySetInnerHTML={{ __html: productDetail?.shortDesc }} />
                                            <div className="product_price price_inner">
                                                {filteredSku ? (
                                                    <p>
                                                        <span>₹{filteredSku?.salePrice.toFixed(2) || '0.00'}</span>
                                                        <del>₹{filteredSku?.mrp.toFixed(2) || '0.00'}</del>
                                                    </p>
                                                ) : (
                                                    <p>
                                                        <span className="unitspanrice">₹{productDetail?.unitPrice} </span>
                                                        <del>₹{productDetail?.mrp}</del>
                                                    </p>
                                                )}
                                                {discountPercent > 0 && (
                                                    <span className="discount_percent mb-0 home_product_discount"><p className="discount_persent_amount">{`${discountPercent.toFixed(0)}% off`} </p><p className="Inclusive">Inclusive of all taxes</p></span>
                                                )}
                                            </div>
                                            <div className="color_seletd_wepper">
                                                <div className="color_seletd_inner">
                                                    <p className="mb-1">Color: <span>{selectedColorName || (productDetail?.productSkuDtos?.length > 0 ? productDetail.productSkuDtos[0]?.colorName : "No color available")}</span></p>
                                                    <div className="color_wrapper">
                                                        <div className="color_circle">
                                                            {productDetail?.productSkuDtos?.length > 0 &&
                                                                Array.from(
                                                                    new Set(
                                                                        productDetail?.productSkuDtos?.map(item => item.colorCode || item.colorName)
                                                                    )
                                                                ).map((color, index) => {
                                                                    const colorId = productDetail?.productSkuDtos?.find(item =>
                                                                        item.colorName === color || item.colorCode === color
                                                                    )?.colorId;

                                                                    const colorName = productDetail?.productSkuDtos?.find(item =>
                                                                        item?.colorName === color || item?.colorCode === color
                                                                    )?.colorName;

                                                                    const skuId = productDetail?.productSkuDtos?.find(item =>
                                                                        item?.colorName === color || item?.colorCode === color
                                                                    )?.skuId;

                                                                    const isFilteredColor = selectedColorId &&
                                                                        productDetail?.productSkuDtos?.some(item =>
                                                                            item.colorId === selectedColorId && (item.colorCode === color || item.colorName === color)
                                                                        );

                                                                    const filteredProductSkuDtos = colorId
                                                                        ? productDetail?.productSkuDtos?.filter(item => item.colorId === colorId)
                                                                        : productDetail?.productSkuDtos;

                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className={`color_box curser-pointer product-item ${isFilteredColor ? 'colorfiltered' : ''}`}
                                                                            // style={{
                                                                            //     backgroundColor: color,
                                                                            // }}
                                                                            onClick={() => handleColorChange(colorId, colorName, skuId)}
                                                                        >
                                                                            <span className="color_images_filter">
                                                                                <img
                                                                                    src={`${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[0]?.imgPath}`}
                                                                                    alt={`Color preview for ${colorName}`}
                                                                                    onError={(e) => {
                                                                                        e.target.style.display = 'none';
                                                                                        e.target.closest('.color_box').style.backgroundColor = color;
                                                                                    }}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="size_wepper mb-0">
                                                <div className="size_flex">
                                                    <p className="mb-1">Size : <span>{selectedSizeType?.name}</span></p>
                                                </div>
                                                <div className="color_wrapper d-sm-flex align-items-center" style={{ gap: '20px' }}>
                                                    <div className="my-2 size_circle">
                                                        {size?.length > 0 &&
                                                            size?.map((item, index) => {
                                                                const isSelected = selectedSizeType?.sizeTypeId === item?.sizeTypeId;

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className={`size_box curser-pointer product-item ${!item?.status ? 'status' : ''} ${isSelected ? 'selected' : ''}`}
                                                                        onClick={() => item?.status && selectedSize(item)}
                                                                    >
                                                                        <span>{item?.name}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                    <div className="sc_lihm">
                                                        <Link to='/sizechart' title="sizechart">
                                                            <p className="mb-0">Size Chart</p>
                                                            <img src="./images/sizechart.svg" alt="" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="counter_wepper">
                                                <div className="counter">
                                                    <span className="down" onClick={decrementQuantity}>
                                                        <i className="fa-solid fa-minus"></i>
                                                    </span>
                                                    <span className="quantity_home">{quantity}</span>
                                                    <span className="up" onClick={incrementQuantity}>
                                                        <i className="fa-solid fa-plus"></i>
                                                    </span>
                                                </div>
                                                <div className="heart_wepper">
                                                    <span onClick={() => onWishlistToggle(productDetail)}><img src="./images/dark-heart.svg" alt="" /></span>
                                                </div>
                                            </div>
                                            <div className="add_cart_wepeer">
                                                <div className="cart_btn_inner">
                                                    <span className="curser-pointer" onClick={() => onBuyNow()}>Buy Now</span>
                                                    <span className="curser-pointer active" onClick={() => onAddCart(productDetail)}>Add to Cart</span>
                                                </div>
                                            </div>
                                            <div className="more_product_details mt-3">
                                                <span onClick={() => onProductDetail(productDetail)}>More Details</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}

export default ProductDetailSection;